document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('.vBundle-offer-container');
  if (!container) return;

  var atcButtons = container.querySelectorAll('.atc-button');
  atcButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      var variantIds = (this.getAttribute('data-variant-ids') || '').split(',');
      var items = variantIds.filter(function(id) { return id; }).map(function(id) {
        return { id: id, quantity: 1 };
      });

      if (items.length === 0) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(response) { return response.json(); })
        .then(function() {
          return fetch('?sections=cart-drawer,cart-icon-bubble');
        })
        .then(function(response) { return response.json(); })
        .then(function(sections) {
          var oldCartDrawerElement = document.querySelector('cart-drawer');
          if (!oldCartDrawerElement) return;

          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            bubble.innerHTML = new DOMParser()
              .parseFromString(sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }

          var newCartDrawerHTML = sections['cart-drawer'];
          var newCartDrawerDOM = new DOMParser().parseFromString(newCartDrawerHTML, 'text/html');
          var newCartDrawerElement = newCartDrawerDOM.querySelector('cart-drawer');
          if (!newCartDrawerElement) return;

          oldCartDrawerElement.replaceWith(newCartDrawerElement);
          var updatedCartDrawer = document.querySelector('cart-drawer');
          if (updatedCartDrawer && typeof updatedCartDrawer.open === 'function') {
            updatedCartDrawer.open();
          }
        })
        .catch(function(error) {
          console.error('Error updating cart drawer:', error);
        });
    });
  });
});
